var React = require('react');

function IconExpand (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M214.6 438.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.4 73.4V160c0-17.7 14.3-32 32-32s32 14.3 32 32v178.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128h-.1ZM32 64C14.3 64 0 49.7 0 32S14.3 0 32 0h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32Z"}));
}

IconExpand.defaultProps = {"fill":"currentColor","viewBox":"0 0 384 448"};

module.exports = IconExpand;

IconExpand.default = IconExpand;
